import O1HD from "../../engines/gameEngine";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../modes/normalMode/BundleResourceConfig";
import { getpawnShopObjMap, pawnShopObjQualityColorAry, pawnShopObjQualityExplainAry } from "../pawnShopGame/pawnShop/config/pawnShopConfig";
import { pawnShopBackpackObjI, pawnShopFixGameSelectDataI } from "../pawnShopGame/pawnShop/const/pawnShopConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopFixSelectItem extends cc.Component {

    @property({type:cc.Sprite,displayName:"背景板"})
    bgNode:cc.Sprite = null;

    @property({type:cc.Sprite,displayName:"显示的物品图片"})
    showSp:cc.Sprite = null;

    @property({type:cc.Label,displayName:"品质节点"})
    qualityLb:cc.Label = null;

    @property({type:cc.RichText,displayName:"已修复文本"})
    fixLb:cc.RichText = null;

    backPackObj:pawnShopFixGameSelectDataI = null;
    selectFun:(node:cc.Node)=>void;

    @property({type:cc.SpriteFrame,displayName:"品质图片"})
    qualitySpAry:cc.SpriteFrame[] = [];

    @property({type:cc.Node,displayName:"选择节点"})
    selectNode:cc.Node = null;

    bindData(backPackObj:pawnShopFixGameSelectDataI,selectFun:(node:cc.Node)=>void){
        this.backPackObj = backPackObj;
        this.selectFun = selectFun;
        this.loadItem();
    }

    loadItem(){
        let id = this.backPackObj.obj.id;
        let objConfig = getpawnShopObjMap()[id];
        this.qualityLb.string = pawnShopObjQualityExplainAry[objConfig.quality];
        this.qualityLb.node.color = pawnShopObjQualityColorAry[objConfig.quality];
        this.bgNode.spriteFrame = this.qualitySpAry[objConfig.quality];
        this.fixLb.string = `<color = #FFFFFF>已修复</c><color = #54FF00>${this.backPackObj.obj.fixCount}</c><color = #FFFFFF>/${this.backPackObj.obj.canFixCount}</c>`;
        this.loadSp(objConfig.name);
    }

    loadSp(name:string){
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`assets/fixGame/obj/sp/${name}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"pawnShopFixSelectItem.ts #36 loadSp Fail");
                return;
            }
            this.showSp.spriteFrame = spr;
        });
    }

    setSelect(isSelect:boolean){
        this.selectNode.active = isSelect;
    }

    //点击自己
    onBtnMe(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.selectFun && this.selectFun(this.node);
    }
    
}
